<div class="ktbl-spacer-top-bottom"></div>

<h6>Wählen Sie hier eine Gebäudeklasse sowie weitere Kategorien, um passende Gebäude zu finden.</h6>


<div>
    <mat-form-field appearance="fill" class="ktbl-input-box">
        <mat-label>Gebäudeklasse wählen</mat-label>
        <mat-select required disableRipple [formControl]="gebklasseFormControl" [errorStateMatcher]="matcher"
            (selectionChange)="onSelectGebklasse($event.value)" panelClass="ktbl-large-select-panel">
            <mat-option *ngFor="let gebklasse of this.localService.gebklasseList.value" [value]="gebklasse.istGebaeude">
                {{ gebklasse.gebKlasse }}
            </mat-option>
        </mat-select>

        <mat-error *ngIf="gebklasseFormControl.hasError('required')">
            Es wird eine Bauliche Anlage benötigt
        </mat-error>
    </mat-form-field>
    <div class="ktbl-spacer-top-bottom"></div>
    <mat-form-field appearance="fill" class="ktbl-input-box">
        <mat-label>{{ tierkategorieText }}</mat-label>
        <mat-select required disableRipple [formControl]="tierkategorieFormControl" [errorStateMatcher]="matcher"
            (selectionChange)="onSelectTierkategorie($event.value)" panelClass="ktbl-large-select-panel">
            <mat-option *ngFor="
            let tierkategorie of this.localService.selectedtierkategorieList
              .value
          " [value]="tierkategorie.idPr">
                {{ tierkategorie.tierkategorie }}
            </mat-option>
        </mat-select>

        <mat-error *ngIf="tierkategorieFormControl.hasError('required')">
            Es wird eine Auswahl benötigt
        </mat-error>
    </mat-form-field>
</div>

<div class="ktbl-spacer-top-bottom"></div>
<mat-accordion class="ktbl-example-headers-align" *ngIf="isMatExpansionVisible" multi>
    <mat-expansion-panel class="ktbl-accordeon-margin-top" [expanded]="false" hideToggle="true" #panel3>
        <mat-expansion-panel-header>
            <mat-panel-title class="ktbl-mat-expension-panel-title">
                <i class="fas fa-filter ktbl-icon-mat-expansion"></i>

                <span class="ktbl-expansion-panel-padding">
                    Filter
                </span>

                <div style="margin-left: auto;">
                    <i *ngIf="!panel3.expanded" class="fa-solid fa-circle-caret-down ktbl-icon-mat-expansion"></i>
                    <i *ngIf="panel3.expanded" class="fa-solid fa-circle-caret-up ktbl-icon-mat-expansion"></i>
                </div>
            </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="component-table-width">
            <div class="row">
                <div id="content_daten_1"></div>
            </div>
        </div>
        <div class="component-table-width">
            <div class="row">
                <div id="content_daten_2"></div>
            </div>
        </div>
    </mat-expansion-panel>
    <mat-expansion-panel class="ktbl-accordeon-margin-top" [expanded]="true" hideToggle="true" #panel>
        <mat-expansion-panel-header>
            <mat-panel-title class="ktbl-mat-expension-panel-title">
                <i class="fas fa-plus ktbl-icon-mat-expansion" (click)="onAddAllEntrys($event)"
                    matTooltip="Alle gefundenen Gebäude zu den ausgewählten Gebäude hinzufügen"
                    [matTooltipPosition]="position.value" [matTooltipClass]="position.value"></i>

                <span class="ktbl-expansion-panel-padding">
                    Gefundene Gebäude ({{ localService.foundGebaeudeList.value.length }} von {{ anzahlGebaeudeTierartTk
                    }})
                </span>

                <div style="margin-left: auto;">
                    <i *ngIf="!panel.expanded" class="fa-solid fa-circle-caret-down ktbl-icon-mat-expansion"></i>
                    <i *ngIf="panel.expanded" class="fa-solid fa-circle-caret-up ktbl-icon-mat-expansion"></i>

                </div>
            </mat-panel-title>

        </mat-expansion-panel-header>


        <div id="content_daten_3"></div>
    </mat-expansion-panel>

    <mat-expansion-panel class="ktbl-accordeon-margin-top" [expanded]="false" hideToggle="true" #panel2>
        <mat-expansion-panel-header>
            <mat-panel-title class="ktbl-mat-expension-panel-title">
                <i class="fas fa-trash ktbl-icon-mat-expansion" (click)="onRemoveAllEntrys($event)"
                    matTooltip="Alle ausgewählten Gebäude entfernen" [matTooltipPosition]="position.value"
                    [matTooltipClass]="position.value"></i>

                <span class="ktbl-expansion-panel-padding">
                    Ausgewählte Gebäude ({{
                    this.localService.selectedGebaeudeList.value.length
                    }})
                </span>

                <div style="margin-left: auto;">
                    <i *ngIf="!panel2.expanded" class="fa-solid fa-circle-caret-down ktbl-icon-mat-expansion"></i>
                    <i *ngIf="panel2.expanded" class="fa-solid fa-circle-caret-up ktbl-icon-mat-expansion"></i>

                </div>
            </mat-panel-title>
        </mat-expansion-panel-header>

        <div id="content_daten_5"></div>

    </mat-expansion-panel>
</mat-accordion>
<div class="ktbl-spacer-top-bottom" *ngIf="isMatExpansionVisible"></div>



<div class="ktbl-button-container">
    <div class="ktbl-button-container-left">
        <!--Absichtlich leerer Container. Wenn doch mal ein Button links sein soll-->
    </div>

    <div class="ktbl-button-container-right">
        <button (click)="this.localService.mainComponentRef.value!.onClickZuErgebnisse()"
            class="ktbl-button-primaer ktbl-button-width-m" type="button">
            Zum Vergleich
            <i class="fas fa-arrow-right ktbl-icon-vertical-align"></i>
        </button>
    </div>

</div>